import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import type { CellKindConversionRejection } from '../pure-pm-in-editor-direct-streaming/transaction-builders/cellKindConversion';

/** Observed commit result, atomically published with final streaming state. */
export const STREAMING_COMMIT_RESULT = 'streamingCommitResult';

/**
 * Exact target recorded by `replaceNode`. The streaming mount consumes it to
 * distinguish a cell target from a row or table whose selection begins in a cell.
 */
export const AI_ORIGINAL_NODE_DATA = 'aiOriginalNodeData';

export interface AIOriginalNodeData {
	originalNode: PMNode | undefined;
}

/**
 * Meta on the terminal commit of a tool call force-finished by the queue timeout.
 * Set by `buildCommitTransaction` and consumed by `aiSessionContextPlugin.apply()`,
 * which records the final positions in `abortedToolCallPositions` for resume.
 */
export const CAPTURE_ABORTED_TOOL_CALL_POSITIONS = 'captureAbortedToolCallPositions';

export interface CaptureAbortedToolCallPositionsData {
	aiContentEndPos: number;
	startPos: number;
	toolCallId: string;
}

/** Terminal cell conversion result, read before document change classification. */
export const CELL_KIND_CONVERSION_RESULT = 'cellKindConversionResult';

export interface CellKindConversionResultData {
	rejection: CellKindConversionRejection | undefined;
}
